import {
  ACCESS_TOKEN_NAME,
  JSON_CONTENT_TYPE,
} from '../../_constant/constants';
import { ReestrDeletePdfDto } from '../../_dto/_reestr/ReestrDeletePdfDto';
import { IApiParams } from '../../_interface/IApiParams';
import { getApi } from '../getApi';

export const apiDeletePdf = async (dto: ReestrDeletePdfDto) => {
  const params: IApiParams = {
    url: '/reestr/deleteReestrPdf.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'DELETE', dto);
};
